// CSRF token utility for Django integration
export const getCsrfToken = () => {
  // Try to get CSRF token from cookie
  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith('csrftoken='))
    ?.split('=')[1];
    
  if (cookieValue) {
    return cookieValue;
  }
  
  // Fallback: try to get from meta tag
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  if (metaTag) {
    return metaTag.getAttribute('content');
  }
  
  console.warn('CSRF token not found');
  return null;
};

// Enhanced fetch with automatic CSRF token inclusion
export const csrfFetch = async (url, options = {}) => {
  const csrfToken = getCsrfToken();
  
  const defaultOptions = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(csrfToken && { 'X-CSRFToken': csrfToken }),
      ...options.headers
    }
  };
  
  return fetch(url, { ...defaultOptions, ...options });
};

// Get CSRF token from Django endpoint
export const fetchCsrfToken = async () => {
  try {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    const response = await fetch(`${API_BASE_URL}/zoulang/account/csrf/`, {
      method: 'GET',
      credentials: 'include'
    });
    
    if (response.ok) {
      const data = await response.json();
      return data.csrfToken;
    }
  } catch (error) {
    console.error('Failed to fetch CSRF token:', error);
  }
  return null;
};